import BaseClass from "./BaseClass";

export default class SharedOauth extends BaseClass {
  constructor(data) {
    super(data);
    Object.keys(this.schema).forEach(v => {
      this[v] || this._set(this, v, undefined);
    });
  }

  static get schema() {
    return {
      uuid: { type: String },
      token_type: { type: v => (v ? String(v) : v) },
      expires_in: { type: Number },
      access_token: { type: v => (v ? String(v) : v) },
      refresh_token: { type: v => (v ? String(v) : v) },
      time_at: { type: Number },
      code: { type: v => (v ? String(v) : v) },
      sharedAmocrm_uuid: { type: v => (v ? String(v) : v) },
      sharedIntegrations_uuid: { type: v => (v ? String(v) : v) }
    };
  }

  static async loadSelfListByAmocrmUUID(uuid) {
    let res = await this._api.query({
      query: require("../../graphql/opupet_query.graphql"),
      variables: {
        class: "\\App\\JStorage\\SPA\\JSSharedOauth",
        method: "findByAmocrmUUID",
        params: [uuid]
      }
    });
    return this.getSelfList(res.data.opupet_query);
  }
}
